module.exports = __webpack_public_path__ + "static/media/gray-search.5fbaab82.svg";